export const ALARM_SYSTEMS_SECTION_TITLE_KEY = 'alarmSystemsSectionTitle';
export const ALARM_SYSTEMS_SECTION_TITLE_DEFAULT = 'Systemy alarmowe';
export const ALARM_SYSTEMS_SECTION_TITLE_EVENT = 'alarmSystemsSectionTitleChanged';

export function normalizeAlarmSystemsSectionTitle(value) {
  if (typeof value === 'string' && value.trim()) return value.trim();
  return ALARM_SYSTEMS_SECTION_TITLE_DEFAULT;
}
